import "moment/locale/pl";

export function dateCarsWeekDaysView(date, count) {
  return date
    .locale("pl")
    .clone()
    .add(count, "day");
}

export function dateCarsWeekDaysViewDisplayinPopout(date, count) {
  return date
    .locale("pl")
    .clone()
    .add(count, "day")
    .format("YYYY-MM-DD");
}

export function dateCarsDayHoursView(date, count) {
  return date
    .locale("pl")
    .clone()
    .add(count, "hour")
    .format("HH");
}

export function timeFixed(time) {
  if (time > 9) {
    return time;
  }

  return `0${time}`;
}
